<template>
  <div class="accessories-item">
    <form-container :loading="loading" :hasData="!!model" @goBack="redirect">
      <template #goback>
        Назад к списку аксессуаров
      </template>
      <template #heading>
        <h1 v-if="model.title">{{ model.title }}</h1>
        <h1 v-else-if="$props.createMode">Создать новый аксессуар</h1>
      </template>
      <template #dates>
        <span v-if="createdAt">Создан: {{ createdAt }}</span>
        <span v-if="updatedAt">Обновлен: {{ updatedAt }}</span>
        <span v-if="deletedAt">Удален: {{ deletedAt }}</span>
      </template>
      <template #content>
        <accessories-form ref="form" :model="model" @imageUploaded="imageUploaded" @imageDeleted="imageDeleted"/>
      </template>
      <template #actions v-if="$props.createMode">
        <div class="actions">
          <button @click="onCreate">Создать</button>
        </div>
      </template>
      <template #actions v-else>
        <button class="red" @click="onRemove">Удалить</button>
        <button class="info" @click="onSave">Сохранить</button>
      </template>
    </form-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import Moment from 'moment';

import options from '@/config/dropzone-options';

import AccessoryModel from '@/models/accessory';

import AccessoriesForm from './AccessoriesForm.vue';
import FormContainer from '@/components/common/FormContainer.vue';

export default {
  name: 'accessories-item',

  props: {
    createMode: Boolean,
  },

  components: {
    FormContainer,
    AccessoriesForm,
  },

  watch: {
    currentItem(model) {
      this.model = new AccessoryModel(model);
    },
  },

  computed: {
    ...mapGetters({
      loading: 'accessories/loading',
      currentItem: 'accessories/currentItem',
      statuses: 'accessories/statuses',
    }),

    createdAt() {
      return this.model ? this.formatDate(this.model.created_at) : null;
    },

    updatedAt() {
      return this.model ? this.formatDate(this.model.updated_at) : null;
    },

    deletedAt() {
      return this.model ? this.formatDate(this.model.deleted_at) : null;
    },
  },

  methods: {
    ...mapActions({
      clearCurrentItem: 'accessories/clearCurrentItem',
      getConfig: 'accessories/getConfig',
      fetchCategories: 'accessoryCategories/fetch',
      fetchOne: 'accessories/fetchOne',
      create: 'accessories/create',
      remove: 'accessories/remove',
      save: 'accessories/save',
    }),

    toast(msg, type) {
      if (type === 'success') {
        this.$snotify.success(msg, null, {
          showProgressBar: false,
        });
      }
      if (type === 'error') {
        this.$snotify.error(msg, null, {
          showProgressBar: false,
        });
      }
    },

    async validateForm() {
      return await this.$refs.form.validate();
    },

    async onSave() {
      const validated = await this.validateForm();

      if (validated) {
        const err = await this.save(this.model.dto);
        if (!err) {
          this.toast('Изменения успешно сохранены.', 'success');
        } else {
          this.toast('Произошла ошибка.', 'error');
        }
      }
    },

    async onRemove() {
      const err = await this.remove(this.model);

      if (!err) {
        this.toast('Аксессуар успешно удалён.', 'success');
        return this.$router.push({ name: 'accessories' });
      } else {
        this.toast('Произошла ошибка.', 'error');
      }
    },

    async onCreate() {
      const validated = await this.validateForm();

      if (validated) {
        const err = await this.create(this.model.dto);
        if (!err) {
          this.toast('Аксессуар успешно создан.', 'success');

          return this.$router.push({
            name: 'accessories-item',
            params: { id: this.currentItem.id },
          });
        } else {
          this.toast('Произошла ошибка.', 'error');
        }
      }
    },

    imageUploaded(url) {
      this.model.image_urls = [...this.model.image_urls, url];
    },

    imageDeleted(url) {
      this.model.image_urls = this.model.image_urls.filter(
        imageUrl => imageUrl !== url
      );
    },

    redirect() {
      this.$router.push({ name: 'accessories' });
    },

    formatDate(date) {
      return date ? Moment(date).format('llll') : null;
    },
  },

  data() {
    return {
      model: null,
    };
  },

  beforeDestroy() {
    this.clearCurrentItem();
  },

  async beforeMount() {
    if (!this.statuses.length) {
      await this.getConfig();
      await this.fetchCategories();
    }

    if (!this.$props.createMode) {
      await this.fetchOne(this.$route.params.id);
    } else {
      this.model = new AccessoryModel();
    }
  },
};
</script>

<style lang="scss" scoped>
.accessories-item {
  flex: 1;
}
</style>
